import * as auditLogConstants from './actionTypes';
import request from './Request';
import constants from '../../config/constants';

export const fetchAuditLogList = (limit,page,filter) => {
  const filterByPage = filter?.filterByPage?.map(item => item.value) || [];
  const filterByChange = filter?.filterByChange?.map(item => item.value) || [];
  const filterByName = filter?.filterByName || "";
  const startDate = filter?.startDate || '';
  const endDate= filter?.endDate || '';
  return (dispatch) => {
    dispatch({
      type: auditLogConstants.FETCH_AUDITLOG_LIST
    });
    request({
        method: 'post',
        headers:{
          "Authorization": `Bearer ${window.sessionStorage.getItem("tokenDetail")}`
        },
        url:`${constants.BASE_URL}audit/get?limit=${limit}&page=${page}&nameSearch=${filterByName}&filterByChange=${filterByChange}&filterByPage=${filterByPage}&sortOrder=desc&sortBy=modifiedTime&filterByStartDate=${startDate}&filterByEndDate=${endDate}`,  
    })
      .then((response) => {
        dispatch({
          type: auditLogConstants.FETCH_AUDITLOG_LIST_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: auditLogConstants.FETCH_AUDITLOG_LIST_FAILURE,
          payload: error?.response?.data
        });
      })
  }

}

export const fetchAuditUserList = (search) => {
  const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));
  const searchName= search? search : ""
  return (dispatch) => {
    dispatch({
      type: auditLogConstants.FETCH_AUDITUSER_LIST
    });
    request({
        method: 'get',
        headers:{
          "Authorization": `Bearer ${window.localStorage.getItem("tokenDetail")}`
        },
        url:`${constants.BASE_URL}lov/user?searchParam=${searchName}`,  
    })
      .then((response) => {
        dispatch({
          type: auditLogConstants.FETCH_AUDITUSER_LIST_SUCCESS,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: auditLogConstants.FETCH_AUDITUSER_LIST_FAILURE,
          payload: error?.response?.data
        });
      })
  }

}